import moment from "moment";

// Set default due date and time to one week from today at noon
const defaultDueDate = moment()
  .hour(12)
  .minute(0)
  .seconds(0)
  .add(7, "days");

// Setting up the default state for the container, so we can import it within
// the component itself as well as any tests

const defaultDevState = {
  userInput: {
    name: {
      val: "Jonathan Requester",
      isValid: true
    },
    email: {
      val: "mnaylor@utk.edu",
      isValid: true
    },
    phone: {
      val: "(865) 974-7866",
      isValid: true
    },
    title: {
      val: "TEST",
      isValid: true
    },
    type: {
      val: "paint", // Must match the text in option element exactly
      isValid: true
    },
    facility: {
      val: "atc", // Must match the text in the option element exactly
      isValid: true
    },
    due: {
      val: undefined
    },
    description: {
      val: "SOME DESCRIPTION",
      isValid: true
    }
  }
};

// Setting up the default state for the container, so we can import it within
// the component itself as well as any tests
const defaultState = {
  userInput: {
    name: {
      val: "",
      isValid: null
    },
    email: {
      val: "",
      isValid: null
    },
    phone: {
      val: "",
      isValid: null
    },
    title: {
      val: "",
      isValid: null
    },
    type: {
      val: "Choose one", // Must match the text in option element exactly
      isValid: null
    },
    facility: {
      val: "Choose one", // Must match the text in option element exactly
      isValid: null
    },
    due: {
      val: defaultDueDate // A moment() object
    },
    description: {
      val: "",
      isValid: null
    }
  }
};

export default (process.env.NODE_ENV === "production"
  ? defaultState
  : defaultDevState);



// WEBPACK FOOTER //
// ./src/Facilities/config/defaultContainerState.js